var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { _T } from '../../appI18n';
import { appUrl } from '../../utils';
import { useCapitalScrollLock } from './useCapitalScrollLock';
let nextDialogId = 0;
export function CapitalDialogTitle({ children, onClose, id }) {
    return React.createElement(DialogTitle, { disableTypography: true, className: "capital-dialog-title" },
        React.createElement("h2", { id: id }, children),
        onClose ? React.createElement(IconButton, { className: "capital-dialog-close", "aria-label": _T.COMMON_CLOSE || 'Закрыть', onClick: onClose },
            React.createElement("img", { src: appUrl('/Content/capital/assets/dialog-close.svg'), alt: "" })) : null);
}
/** Keeps MUI's focus trap, Escape/backdrop handling and focus restoration. */
export const CapitalDialog = React.forwardRef(function CapitalDialog(_a, ref) {
    var { title, children, actions, width, rawContent = false, className, PaperProps, maxWidth = false, fullWidth = true, onClose } = _a, props = __rest(_a, ["title", "children", "actions", "width", "rawContent", "className", "PaperProps", "maxWidth", "fullWidth", "onClose"]);
    const titleId = useRef();
    if (!titleId.current)
        titleId.current = `capital-dialog-title-${++nextDialogId}`;
    useCapitalScrollLock(props.open, props.disableScrollLock);
    const labelledBy = props['aria-labelledby'] || (title ? titleId.current : undefined);
    const paperWidth = width || (maxWidth ? { xs: 444, sm: 600, md: 960, lg: 1280, xl: 1920 }[maxWidth] : 796);
    return React.createElement(Dialog, Object.assign({}, props, { disableScrollLock: true, ref: ref, onClose: onClose, maxWidth: maxWidth, fullWidth: fullWidth, "aria-labelledby": labelledBy, className: ['capital-dialog', className].filter(Boolean).join(' '), PaperProps: Object.assign(Object.assign({}, PaperProps), { style: Object.assign({ width: paperWidth }, PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.style) }) }),
        title ? React.createElement(CapitalDialogTitle, { id: labelledBy, onClose: onClose ? () => onClose({}, 'escapeKeyDown') : undefined }, title) : null,
        rawContent ? children : React.createElement(DialogContent, { className: "capital-dialog-content" }, children),
        actions ? React.createElement(DialogActions, { className: "capital-dialog-actions" }, actions) : null);
});
